import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { LoggerService, OccEndpointsService, normalizeHttpError } from '@spartacus/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { NewsList } from '../../model/news.model';
import { NewsAdapter } from './news.adapter';

@Injectable({
  providedIn: 'root',
})
export class OccNewsAdapter implements NewsAdapter {
  protected logger = inject(LoggerService);

  constructor(
    protected http: HttpClient,
    protected occEndpoints: OccEndpointsService
  ) {}

  load(start: number, count: number): Observable<NewsList> {
    const url = this.occEndpoints.buildUrl('news', { urlParams: { start, count } });
    return this.http.get<NewsList>(url).pipe(catchError((error) => throwError(normalizeHttpError(error, this.logger))));
  }

  loadByType(start: number, count: number, newsType: string): Observable<NewsList> {
    const url = this.occEndpoints.buildUrl('newsByType', { urlParams: { start, count, newsType } });
    return this.http.get<NewsList>(url).pipe(catchError((error) => throwError(normalizeHttpError(error, this.logger))));
  }

  loadByYear(start: number, count: number, newsYear: string): Observable<NewsList> {
    const url = this.occEndpoints.buildUrl('newsByYear', { urlParams: { start, count, newsYear } });
    return this.http.get<NewsList>(url).pipe(catchError((error) => throwError(normalizeHttpError(error, this.logger))));
  }

  loadByTypeAndYear(start: number, count: number, newsType: string, newsYear: string): Observable<NewsList> {
    const url = this.occEndpoints.buildUrl('newsByTypeAndYear', {
      urlParams: { start, count, newsType, newsYear },
    });
    return this.http.get<NewsList>(url).pipe(catchError((error) => throwError(normalizeHttpError(error, this.logger))));
  }
}
